import { render } from "./TahunAktifForm.vue?vue&type=template&id=091acd5b"
import script from "./TahunAktifForm.vue?vue&type=script&lang=js"
export * from "./TahunAktifForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__